export enum AssignmentStatus {
  BEFORE_START = 1,
  AFTER_START_BEFORE_DUE_NOT_SUBMITTED,
  AFTER_START_BEFORE_DUE_SUBMITTED,
  AFTER_DUE_NOT_SUBMITTED,
  AFTER_DUE_SUBMITTED_BEFORE_DUE,
  AFTER_DUE_SUBMITTED_AFTER_DUE
}

export enum AudioAccent {
  US,
  BRITISH,
  AUSTRALIAN
}

export interface Category {
  uuid: string;
  name: string;
}

export enum ContentType {
  CHAPTER = 2,
  SECTION = 3,
  EXERCISE = 11
}

export interface CourseLevels {
  cefrj: string[];
  eiken: string[];
  toeic: string[];
}

export interface Definition {
  pos: string;
  meanings: Meaning[];
}

export enum ExerciseType {
  CHAT = 1,
  DEMO,
  DICTATION,
  DRILL_VOCABULARY,
  DRILL_LISTENING,
  DRILL_PRONUNCIATION,
  QUIZ_LISTENING,
  PICTURE_MATCH,
  DRILL_TYPING,
  SINGLE_SENTENCE_READING,
  QUIZ_TRANSLATION,
  DRILL_TRANSLATION
}

export interface Meaning {
  meaning: string;
  sampleSentence: string;
}

export enum TrophyType {
  BRONZE = 1,
  SILVER,
  GOLD
}

export interface Word {
  audio: string;
  audioFallback?: string;
  definition: Definition[];
  ipa: string[];
  pronunciationCardUuid: string;
  sentenceSpelling: string;
  spelling: string;
  uuid: string;
}
